import { PropsWithChildren } from 'react';

type ShowMoreContainerProps = {
  enableToggle: boolean;
  toggleState: boolean;
};

export const ShowMoreContainer = ({
  enableToggle,
  toggleState,
  children,
}: PropsWithChildren<ShowMoreContainerProps>) => {
  if (!enableToggle) {
    return <>{children}</>;
  }

  if (!toggleState) {
    return null;
  }

  return <>{children}</>;
};
